import * as React from 'react';
import { TileLayout } from '@progress/kendo-react-layout';
import { UsersTable } from '../components/users/UsersTable.jsx' 


export const Users = () => {

   const [data, setData] = React.useState([
     {
       col: 1,
       colSpan: 4,
       rowSpan: 2,
     }
   ]);
   const tiles = [
     {
       header: 'Users',
       body: <UsersTable/>,
     }
   ];
   const handleReposition = (e) => {
     setData(e.value);
   };
   return (
     <TileLayout
       columns={4}
       rowHeight={400}
       positions={data}
       gap={{
         rows: 10,
         columns: 10,
       }}
       items={tiles}
       onReposition={handleReposition}
     />
   );
 };